<template>
  <c-main>
    <c-row>
      <c-col md="12">
        <form @submit.prevent="submit">
          <c-panel title="API Key">
            
            <!--<c-form-field label="Client*:">
              <c-form-select
                v-model="apikey.clientid"
                :options="clients"
                v-bind:status="$v.apikey.clientid.$error ? 'danger' : ''"
              />
              <span
                v-if="apikey.submitted && !$v.apikey.clientid.required"
                class="form-help u-color-danger"
              >Client is required.</span>
            </c-form-field>-->
            
            <c-form-field label="Name*">
              <c-form-input
                v-bind:autocomplete="'name'"
                v-bind:status="$v.apikey.name.$error ? 'danger' : ''"
                v-model="apikey.name"
              ></c-form-input>
              <span
                v-if="apikey.submitted && !$v.apikey.name.required"
                class="form-help u-color-danger"
              >Name is required.</span>
            </c-form-field>

            <c-form-field label="Type*:">
              <c-form-select
                v-model="apikey.type"
                :options="apikeyTypes"
                v-bind:status="$v.apikey.type.$error ? 'danger' : ''"
              />
              <span
                v-if="apikey.submitted && !$v.apikey.type.required"
                class="form-help u-color-danger"
              >Type is required.</span>
            </c-form-field>

            <c-form-field label="Whitelist IP Addresses (keep empty for any, use comma for multiple)">
              <c-form-input
                v-model="apikey.ips"
              ></c-form-input>              
            </c-form-field>

            <div class="u-text-right" slot="footer">
              <c-button type="primary" smart>Save</c-button>
            </div>
          </c-panel>

          <c-panel title="API Key" v-if="apikey._id">
            <c-row>
              <c-col>
                <c-form-field :label="apikey.api_key">
                </c-form-field>
              </c-col>              
            </c-row>            
          </c-panel>
        </form>
      </c-col>
    </c-row>
  </c-main>
</template>

<script>
import FlatPickr from "cover/vendors/flatpickr";
import { required, email, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  components: {
    [FlatPickr.name]: FlatPickr,
  },
  data() {
    return {
      apikey: {
        name: "",
        //clientid: "",
        type: "",
        ips: "",
        submitted: false,
      },
    };
  },
  validations: {
    apikey: {
      //clientid: { required },
      name: { required },
      type: { required }
    },
  },
  computed: {
    ...mapState(["apikeyTypes", "clients"]),
  },
  created() {
    let _this = this;
    if (this.$route.params && this.$route.params.id) {
      this.$axios
        .get(
          _this.$cfg.API_URL + "/settings/api-key?_id=" + this.$route.params.id
        )
        .then((res) => {
          if (res.data.status == "ok") {
            this.apikey = res.data.data.apikey;
          }
        });
    }
  },
  methods: {   
    submit: function () {
      let _this = this;
      this.apikey.submitted = true;
      this.$v.apikey.$touch();
    
      // if its still pending or an error is returned do not submit
      if (this.$v.apikey.$pending || this.$v.apikey.$error) return;

      const vm = this.$toast.loading("Saving...");

      vm.show();
      this.$axios
        .post(_this.$cfg.API_URL + "/settings/api-key", this.apikey)
        .then((res) => {
          if (res.data.status == "ok") {
            this.$notify({
              type: "success",
              title: "API Key is saved",
              closeable: true,
              duration: 5000,
            });
            vm.hide();
            this.$router.push({ name: "Settings" });
          }
        })
        .catch((err) => {
          this.$notify({
            type: "danger",
            title: "Server error",
            content: "err",
            closeable: true,
            duration: 5000,
          });
          vm.hide();
        });
    },
  },
};
</script>